import axios from "axios";

interface IConstants {
    BACKEND_URL: string;
    API_KEY: string;
    INACTIVITY_LOGOUT_TIME: number;
    INACTIVITY_WARNING_TIME: number;
    MODE: string;
    LICENSE_ID: string;
}

export const API_BASE_URL_FALLBACK = "http://localhost:4000";

const constants: IConstants = {
    BACKEND_URL: process.env.REACT_APP_API_BASE_URL || API_BASE_URL_FALLBACK,
    API_KEY: process.env.REACT_APP_API_KEY || "",
    INACTIVITY_LOGOUT_TIME: 45,
    INACTIVITY_WARNING_TIME: 30,
    MODE: process.env.REACT_APP_MODE as string,
    LICENSE_ID: process.env.REACT_APP_LICENSE_ID as string,
};

export const UPDATE_TOKEN_INTERVAL = 180; // seconds
export const REFRESH_TOKEN_STORAGE_KEY = "refreshToken";
export const APP_SETTINGS_STORAGE_KEY = "appSettings";
export const LICENSE_ID_STORAGE_KEY = "licenseId";
export const UPGRADE_OFFLINE_TOKEN_ATTEMPT_KEY = "kc_upgrade_attempt";

export const UPDATE_TOKEN_TIMEFRAME = 30;

export const isDev = process.env.REACT_APP_ENV === "development";

export default constants;
